import { createApp } from 'vue';
import App from './App.vue';
import cContainer from '@/components/grid/c-container.vue';
import '@/styles/global.scss';

createApp(App)
    .component('c-container', cContainer)
    .mount('#app');
